
namespace GeniuzPOS.LogManage {

    @Serenity.Decorators.registerClass()
    export class LogRefundDialog extends Serenity.EntityDialog<LogRefundRow, any> {
        protected getFormKey() { return LogRefundForm.formKey; }
        protected getIdProperty() { return LogRefundRow.idProperty; }
        protected getLocalTextPrefix() { return LogRefundRow.localTextPrefix; }
        protected getNameProperty() { return LogRefundRow.nameProperty; }
        protected getService() { return LogRefundService.baseUrl; }
        protected getDeletePermission() { return LogRefundRow.deletePermission; }
        protected getInsertPermission() { return LogRefundRow.insertPermission; }
        protected getUpdatePermission() { return LogRefundRow.updatePermission; }

        protected form = new LogRefundForm(this.idPrefix);

    }
}